import React from 'react'
import FormUi from './FormUi'

function Form({children,formik,submitDisplayNone,gridNot,toast}) {
  return (
    <FormUi children={children} formik={formik} submitDisplayNone={submitDisplayNone} gridNot={gridNot} toast={toast}/>
  )
}

export default Form